/**
 * Format a numeric value as a USD currency string.
 *
 * @example formatUSD(12.5)  // "$12.50"
 * @example formatUSD(1000)  // "$1,000.00"
 */
export const formatUSD = (value: number): string =>
  `$${value.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`
